import { useEffect, useState } from "react";
import ScheduleFilters from "./ScheduleFilters/ScheduleFilters";
import ScheduleContent from "./ScheduleContent/ScheduleContent";
import { formatDate } from "../../utils/formatDateTime";
import { useDispatch, useSelector } from "react-redux";
import { getVehicleList } from "../../redux-sagas/actions/index";
import "./scheduleTestDrive.css";
import { format, addDays } from "date-fns";
import getBrands from "../../utils/getBrands";
import { getVehiclesParams } from "../../utils/getParams";

const ScheduleTestDrive = () => {
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings);
  const minimumBookingDays = settings?.brandGroupConfiguration?.minimumBookingDays ?? 0;
  const defaultDate = addDays(new Date(), minimumBookingDays);
  const toReschedule = useSelector((state) => state.toReschedule);
  const [queryParams, setQueryParams] = useState({
    take: 3,
    date: toReschedule
      ? formatDate(
        new Date(toReschedule.bookingDate) <= defaultDate
          ? defaultDate
          : new Date(toReschedule.bookingDate)
      )
      : formatDate(defaultDate),
    showrooms: "",
    models: "",
    orderBy: "",
    vehicleId: toReschedule ? toReschedule.vehicleId : "",
    clientDateTime: format(new Date(), "yyyy-MM-dd HH:mm"),
    brands: getBrands()
  });

  const [filters, setFilters] = useState({
		models: [],
		showrooms: []
	});

  const handleRemoveFilter = (type, current) => {
		const isSame = (item) =>
			(item.modelName ?? item.showroomName) === (current.modelName ?? current.showroomName);

		// If current item is already in models/showrooms array,
		// remove from array.
		// If not, add to array
		if (filters[type].find((item) => isSame(item))) {
			setFilters({
				...filters,
				[type]: filters[type].filter((item) => !isSame(item))
			});
		} else {
			setFilters({
				...filters,
				[type]: filters[type].concat(current)
			});
		}

    setFetchVehicleData(true);
	};

  const [fetchVehicleData, setFetchVehicleData] = useState(true);

  useEffect(() => {
    if (fetchVehicleData)
      dispatch(getVehicleList(getVehiclesParams(queryParams)));
  }, [queryParams]);


  return (
    <div className='schedule-cont'>
      <ScheduleFilters
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        filters={filters}
        setFilters={setFilters}
        removeFilter={handleRemoveFilter}
        setFetchVehicleData={setFetchVehicleData}
      />
      <ScheduleContent
        defaultDate={defaultDate}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        filters={filters}
        setFilters={setFilters}
        removeFilter={handleRemoveFilter}
        setFetchVehicleData={setFetchVehicleData}
      />
    </div>
  );
};

export default ScheduleTestDrive;
